module.exports = __webpack_public_path__ + "static/img/icon-3-2.f639dbc9.png";